import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { AssetColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';

const BlockAsset: VFC<BlockProps> = ({
  blockBackgroundType,
  blockContent,
  presentOption,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const columnData = blockContent?.columns?.list || [];
  const contextContent = contentFilter(
    blockContent.context,
    presentMode,
    presentOption,
  );

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      blockBackgroundType={blockBackgroundType}
      contextContent={contextContent}
      offset={2}
      titleCentered
      columns={columnData.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden &&
            (column.name === 'asset' || column.name === 'media') &&
            'asset' in column.elements && (
              <AssetColumn
                background={blockBackgroundType}
                elements={column.elements}
              />
            )}
        </>
      ))}
    />
  );
};

BlockAsset.displayName = 'BlockAsset';
export default BlockAsset;
